import React, { useEffect, useRef, useState } from "react";
// import FloatingLabelInput from 'react-floating-label-input';
import { Form } from "react-router-dom";
// import FloatingSelectInput from '../FloatingSelectInput';
import Select from "react-select";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import DatePicker from "react-datepicker";
import { userAuthImage } from "../../config/imagesLink";
import { useFormik } from "formik";
import { createProfileValidations } from "../Validations";
import moment from "moment";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import Flatpickr from 'react-flatpickr';
import { Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";

const options = [
  { value: "USA", label: "United States" },
  { value: "CAN", label: "Canada" },
  // Add more countries as needed
];



const Profile = () => {
  const [data, setData] = useState([]);
  const language = localStorage.getItem("Lang");
  // console.log("dataaaaaa", data);
  const { t } = useTranslation();


    // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------

  

  const fetchData = async () => {
    try {
      const result = await axios.post(`/UserProfile/GetOwnInfo`, {
        sessionId,
        langKey: language === "en" ? "" : language,
        
        deviceType: "Web",
      });
      const Response = result.data.responseData;
      // console.log('result', Response);
      setData(Response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const resetToasts = () => {
    setToastMessage("");
    setShowToast(false);
    setWarningToastMessage("");
    setShowWarningToast(false);
    setErrorToastMessage("");
    setShowErrorToast(false);
  };

  const getApiErrorMessage = (error) => {
    const responseData = error?.response?.data;

    if (typeof responseData?.message === "string" && responseData.message.trim()) {
      return responseData.message.trim();
    }

    const validationErrors = responseData?.errors;
    if (validationErrors && typeof validationErrors === "object") {
      const firstValidationMessage = Object.values(validationErrors)
        .flat()
        .find((message) => typeof message === "string" && message.trim());

      if (firstValidationMessage) {
        return firstValidationMessage.trim();
      }
    }

    if (typeof responseData?.title === "string" && responseData.title.trim()) {
      return responseData.title.trim();
    }

    return "Something went wrong.";
  };
  //   Get Language Data
  const [languageValue, setlanguageValue] = useState("");
  const [languageOptionList, setlanguageOptionsList] = useState([]);
  const getLanguageData = () => {
    try {
      axios
        .get(`/Master/GetLanguageDDL?LangKey=${language}`)
        .then((response) => {
          // console.log("language data", response.data.responseData);
          setlanguageOptionsList(response.data.responseData);
          // setLoading(false);
        })
        .catch((error) => { });
    } catch (error) { }
  };

  let languageOptions = languageOptionList.map((val) => {
    return { value: val.langId, label: val.name, id: val.langId };
  });

  const selectLanguage = (val) => {
    // console.log("lang", val.value);
    setlanguageValue(val.value);
  };

  useEffect(() => {
    getLanguageData();
  }, []);

 

  const [countryData, setCountryData] = useState([]);
  const [countryId, setCountryId] = useState("");
  const [countrySearch, setCountrySearch] = useState(null);
  const getCountry = () => {
    axios   
      .get(`Master/GetCountryDDL?search=${countrySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        console.log("countrydata", res);
        
        const data = res.map((item) => ({
          value: item.countyId,
          label: item.countryName,
          code: item.phoneCode,
        }));
        setCountryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (countrySearch) {
      getCountry();
    }
  }, [countrySearch]);

   const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState("");
  const [citySearch, setCitySearch] = useState(null);
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&CountryID=${countryId || ""}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);


  // Get Gender Data
  const [genderValue, setGenderValue] = useState("");
  const [genderOptionList, setGenderOptionList] = useState([]);
  const getGenderData = () => {
    try {
      axios
        .get(`/Master/GetGenderDDL?LangKey=${language}`)
        .then((response) => {
          // console.log("gender data", response.data.responseData);
          setGenderOptionList(response.data.responseData);
          // setLoading(false);
        })
        .catch((error) => { });
    } catch (error) { }
  };

  let genderOptions = genderOptionList.map((val) => {
    return { value: val.gndrId, label: val.name, id: val.gndrId };
  });

  const selectGender = (val) => {
    // console.log("gender", val.value);
    setGenderValue(val.value);
  };

  useEffect(() => {
    getGenderData();
  }, []);
  const [startDate, setStartDate] = useState(null);

  const sessionId = localStorage.getItem("sessionId");
  const [selectedImage, setSelectedImage] = useState(null);
  const [bgSelectedImage, setBgSelectedImage] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [backgroudImage, setBackgroundImage] = useState(null);
  const fileInputRef = useRef(null);
  const fileInputRefBg = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const handleBgClick = () => {
    fileInputRefBg.current.click();
  };

  const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfilePic(selectedFile);
    setSelectedImage(URL.createObjectURL(selectedFile));
  };

  const handleBgImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setBackgroundImage(selectedFile);
    setBgSelectedImage(URL.createObjectURL(selectedFile));
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    dob: "",
    additionalName: "",
  };

  const [phoneNumber, setphoneNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [initialProfileValues, setInitialProfileValues] = useState(null);

  const normalizeDate = (value) =>
    value ? moment(value).format("YYYY-MM-DD") : "";

  const normalizeValue = (value) => (value ?? "").toString().trim();

  const hasProfileChanges = Boolean(initialProfileValues) && (
    normalizeValue(firstName) !== normalizeValue(initialProfileValues.firstName) ||
    normalizeValue(lastName) !== normalizeValue(initialProfileValues.lastName) ||
    normalizeValue(phoneNumber) !== normalizeValue(initialProfileValues.phoneNumber) ||
    normalizeValue(countryId) !== normalizeValue(initialProfileValues.countryId) ||
    normalizeValue(cityId) !== normalizeValue(initialProfileValues.cityId) ||
    normalizeValue(genderValue) !== normalizeValue(initialProfileValues.genderValue) ||
    normalizeDate(startDate) !== normalizeDate(initialProfileValues.startDate)
  );


  // const UpdateProfile = async () => {
    
  //   try {
  //     const formData = new FormData();
  //     formData.append("DeviceType", "Web");
  //     formData.append("sessionId", sessionId);
  //     formData.append("Dob", startDate === null ? '' : moment(startDate).format("L"));
  //     formData.append("CityID", cityId === null ? '' : cityId);
  //     formData.append("GenderId", genderValue);
  //     formData.append("LastName", lastName);
  //     formData.append("PhoneNumber", phoneNumber);
  //     formData.append("CntryID", countryId === null ? '' : countryId);
  //     formData.append("FirstName", firstName);
  //     localStorage.setItem("firstName", firstName);
  //     localStorage.setItem("lastName", lastName);
  //     formData.append("Language",   language === "en" ? "" : language,);

  //     const res = await axios.post(
  //       "/UserProfile/UpdateCompleteInfo",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     console.log("response: ", res);
  //     setToastMessage(res.data.message);
  //     setShowToast(true);
  //   } catch (e) {
  //     console.log(e);
  //     if (e.response && e.response.status === 404) {
  //       setWarningToastMessage(e.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(e.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };


 const UpdateProfile = async (event) => {
  event?.preventDefault();
  resetToasts();
  if (
    !startDate   ||
    !countryId   ||
    !genderValue  ||
    !firstName   ||
    !lastName   ||
    !cityId  
  ) {
    setWarningToastMessage(t("modals.Please fill all the required fields"));
    setShowWarningToast(true);
  } else {
    try {
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("Dob", moment(startDate).format("YYYY-MM-DD"));
      formData.append("CityID", cityId);
      formData.append("GenderId", genderValue);
      formData.append("LastName", lastName);
      formData.append("PhoneNumber", phoneNumber);
      formData.append("CntryID", countryId);
      formData.append("FirstName", firstName);
      formData.append("Language", language === "en" ? "" : language);

      localStorage.setItem("firstName", firstName);
      localStorage.setItem("lastName", lastName);

      const res = await axios.post(
        "/UserProfile/UpdateCompleteInfo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (e) {
      if (e?.response?.status === 404) {
        setWarningToastMessage(getApiErrorMessage(e));
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(getApiErrorMessage(e));
        setShowErrorToast(true);
      }
    }
  }
};


  useEffect(() => {
    if (data) {
      setlanguageValue(data?.langId);
      setGenderValue(data?.genderId);
      setCityId(data?.cityID);
      setCitySearch(data?.cityName);
      setCountryId(data?.countryID);
      setCountrySearch(data?.countryName);
      setphoneNumber(data?.phoneNumber);
      setStartDate(data?.dob ? new Date(data.dob) : null); // Convert string to Date
      setFirstName(data?.firstName);
      setLastName(data?.lastName);
      setProfilePic(data?.profilPic);
      setBackgroundImage(data?.backGroundImage);
      setInitialProfileValues({
        firstName: data?.firstName || "",
        lastName: data?.lastName || "",
        phoneNumber: data?.phoneNumber || "",
        countryId: data?.countryID || "",
        cityId: data?.cityID || "",
        genderValue: data?.genderId || "",
        startDate: data?.dob ? new Date(data.dob) : null,
      });
    }
  }, [data]);
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };


  return (
    <>
      <div className="setting-header">
        <h4>{t("Newsfeed.Profile Setting")}</h4>
      </div>
      <Form>
        <div className="row p-4 justify-content-center">
          <div className="row p-4 pt-3 settings setting-section">
              <div className="col-md-6 mt-2 ps-1 mb-2 userInput">
                <label className="mb-0">
                   {t("Newsfeed.First Name")}<span className="text-danger ms-2">*</span>
                </label>
                <Input
                  type="text"
                  value={firstName}
                  // placeholder="Enter field"
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>

              <div className="col-md-6 mt-2 ps-1 mb-2 userInput">
                <label>
                   {t("Newsfeed.Last Name")}<span className="text-danger ms-2">*</span>
                </label>
                <Input
                  type="text"
                  value={lastName}
                  // placeholder="Enter field"
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="col-md-6 mt-2 ps-1">
                <label htmlFor="about">{t("User Profile.Gender")}<span className="text-danger ms-2">*</span> </label>
                <ReactSelect
                  value={genderOptions.find(
                    (option) => option.value === genderValue
                  )}
                  options={genderOptions}
                  onChange={selectGender}
                  loadOptions={selectGender}
                  placeholder={t("Newsfeed.Select Gender")}
                  styles={customStyles}
                />
              </div>
              <div className="col-md-6 mt-2 ps-1 mb-2 userInput NewDateUserInput">
                <label htmlFor="about">{t("User Profile.DOB")}<span className="text-danger ms-2">*</span></label>
                <div>
                  {/* <Flatpickr
                    className="form-control"
                    defaultValue={startDate}
                    onChange={(date) => setStartDate(date[0])}
                    id="dob"
                    options={{
                      maxDate: "today" // Disables future dates
                    }}
                  /> */}
                  <Flatpickr
                    className="form-control"
                    value={startDate}
                    onChange={(date) => setStartDate(date[0])} // Flatpickr returns an array
                    id="dob"
                    options={{
                      maxDate: "today", // Disable future dates
                      defaultDate: startDate || undefined, // Set the default selected date
                      onReady: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Call the function to stop scroll on year
                      },
                      onOpen: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Also prevent scroll when the picker opens
                      },
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 mt-2 ps-1">
                <label htmlFor="about">{t("User Profile.Country")}<span className="text-danger ms-2">*</span></label>
                <Select
                  value={countryData.find(
                    (option) => option.value === countryId
                  )}
                  isClearable
                  options={countryData}
                  onChange={(selectedOption) => 
                    setCountryId(selectedOption ? selectedOption.value : "")}
                  placeholder={t("SearchJob.Select Country")}
                  onInputChange={(inputValue) => {
                    setCountrySearch(inputValue);
                  }}
                  styles={customStyles}
                />
              </div>
               <div className="col-md-6 mt-2 ps-1">
                <label htmlFor="about">{t("User Profile.City")}<span className="text-danger ms-2">*</span></label>
                <Select
                  value={cityData.find(
                    (option) => option.value === cityId
                  )}
                  isClearable
                  options={cityData}
                  onChange={(selectedOption) => 
                    setCityId(selectedOption ? selectedOption.value : "")}
                  placeholder={t("Newsfeed.Select City")}
                  onInputChange={(inputValue) => {
                    setCitySearch(inputValue);
                  }}
                  styles={customStyles}
                />
              </div>
               <div className="col-md-6 mt-2 ps-1 mb-2 userInput">
                <label className="mb-0">
                 {t("User Profile.Phone Number")}
                 {/* <span className="text-danger ms-2">*</span> */}
                </label> 
                  <Input
                    type="text"
                    inputMode="numeric"
                    pattern="\\d*"
                    maxLength={10}
                    value={phoneNumber}
                    placeholder={t("Newsfeed.Enter phone number")}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setphoneNumber(onlyDigits);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const paste = (e.clipboardData || window.clipboardData).getData("text");
                      const digits = paste.replace(/\D/g, "").slice(0, 10 - phoneNumber.length);
                      setphoneNumber((prev) => (prev + digits).slice(0, 10));
                    }}
                  />
              </div>
              

              <div className="text-end">
                <button
                  type="submit"
                  className="mainBtn1 mt-3 text-center"
                  onClick={UpdateProfile}
                  disabled={!hasProfileChanges}
                >
                  {t("Newsfeed.Update")}
                </button>
              </div>
          </div>
 
        </div>
      </Form>
      <SuccessToast
        show={showToast && Boolean(toastMessage)}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast && Boolean(warningToastMessage)}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast && Boolean(ErrorToastMessage)}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Profile;
